import { CardContent, Skeleton, Stack, useTheme } from "@mui/material";
import { Card } from "@src/appV2/redesign/system/ui-components";

function SupportShiftCardSkeleton() {
  const theme = useTheme();

  return (
    <Card
      outlined
      variant="quaternary"
      role="progressbar"
      aria-label="Loading shift"
      sx={{ marginBottom: 4 }}
    >
      <CardContent sx={{ padding: theme.spacing(4) }}>
        <Stack direction="row" spacing={4} alignItems="flex-start">
          <Skeleton variant="rounded" width={48} height={48} />
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height="1.25rem" />
            <Skeleton variant="text" width="40%" height="1rem" />
            <Skeleton variant="text" width="50%" height="1rem" />
            <Skeleton variant="text" width="30%" height="0.875rem" />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

/**
 * Loading state showing skeleton cards while shifts are being fetched.
 */
export function GuidedSupportLoadingState() {
  return (
    <Stack>
      {Array.from({ length: 5 }, (_, index) => (
        <SupportShiftCardSkeleton key={index} />
      ))}
    </Stack>
  );
}
